"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.fill");
var _slicedToArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es6.number.constructor");
var _utils = require("@/utils");
var _lang = require("@/lang");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    canvasWidth: {
      type: Number,
      default: 350
    },
    // 主canvas的宽
    canvasHeight: {
      type: Number,
      default: 200
    },
    // 主canvas的高
    // 是否出现，由父级控制
    show: {
      type: Boolean,
      default: true
    },
    puzzleScale: {
      type: Number,
      default: 1
    },
    // 拼图块的大小缩放比例
    sliderSize: {
      type: Number,
      default: 50
    },
    // 滑块的大小
    range: {
      type: Number,
      default: 10
    },
    // 允许的偏差值
    // 所有的背景图片
    imgs: {
      type: Array
    },
    successText: {
      type: String,
      default: function _default() {
        return (0, _lang.getLanguage)() === 'zh' ? '验证成功' : 'Verification successful';
      }
    },
    failText: {
      type: String,
      default: function _default() {
        return (0, _lang.getLanguage)() === 'zh' ? '验证失败' : 'Verification failed';
      }
    },
    sliderText: {
      type: String,
      default: function _default() {
        return (0, _lang.getLanguage)() === 'zh' ? '向右滑动完成验证' : 'Slide to complete verification';
      }
    },
    showData: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      verSuccess: false,
      isShow: false,
      mouseDown: false,
      // 鼠标是否在按钮上按下
      startWidth: 50,
      // 鼠标点下去时父级的width
      startX: 0,
      // 鼠标按下时的X
      newX: 0,
      // 鼠标当前的偏移X
      pinX: 0,
      // 拼图的起始X
      pinY: 0,
      // 拼图的起始Y
      loading: null,
      // 是否正在加在中，主要是等图片onload
      isCanSlide: false,
      // 是否可以拉动滑动条
      error: false,
      // 图片加在失败会出现这个，提示用户手动刷新
      infoBoxShow: false,
      // 提示信息是否出现
      infoText: "",
      // 提示等信息
      infoBoxFail: false,
      // 是否验证失败
      timer1: null,
      // setTimout1
      closeDown: false,
      // 为了解决Mac上的click BUG
      isSuccess: false,
      // 验证成功
      imgIndex: -1,
      // 用于自定义图片时不会随机到重复的图片
      isSubmting: false // 是否正在判定，主要用于判定中不能点击重置按钮
      // resetSvg,
    };
  },
  /** 生命周期 **/mounted: function mounted() {
    // document.body.appendChild(this.$el);
    document.addEventListener("mousemove", this.onRangeMouseMove, {
      passive: false
    });
    document.addEventListener("mouseup", this.onRangeMouseUp, {
      passive: false
    });
    document.addEventListener("touchmove", this.onRangeMouseMove, {
      passive: false
    });
    document.addEventListener("touchend", this.onRangeMouseUp, {
      passive: false
    });
    if (this.show) {
      document.body.classList.add("vue-puzzle-overflow");
      this.reset();
    }
    // if (this.showData) {
    //   this.isShow = this.showData;
    //   console.log('我收到了验证！');
    // }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timer1);
    document.removeEventListener("mousemove", this.onRangeMouseMove, {
      passive: false
    });
    document.removeEventListener("mouseup", this.onRangeMouseUp, {
      passive: false
    });
    document.removeEventListener("touchmove", this.onRangeMouseMove, {
      passive: false
    });
    document.removeEventListener("touchend", this.onRangeMouseUp, {
      passive: false
    });
  },
  /** 监听 **/
  watch: {
    show: function show(newV) {
      // 每次出现都应该重新初始化
      if (newV) {
        document.body.classList.add("vue-puzzle-overflow");
        this.reset();
      } else {
        this.isSubmting = false;
        this.isSuccess = false;
        this.infoBoxShow = false;
        document.body.classList.remove("vue-puzzle-overflow");
      }
    }
  },
  /** 计算属性 **/
  computed: {
    // styleWidth是底部用户操作的滑块的父级，就是轨道在鼠标的作用下应该具有的宽度
    styleWidth: function styleWidth() {
      var w = this.startWidth + this.newX - this.startX;
      return w < this.sliderBaseSize ? this.sliderBaseSize : w > this.canvasWidth ? this.canvasWidth : w;
    },
    // 图中拼图块的60 * 用户设定的缩放比例计算之后的值 0.2~2
    puzzleBaseSize: function puzzleBaseSize() {
      return Math.round(Math.max(Math.min(this.puzzleScale, 2), 0.2) * 52.5 + 6);
    },
    // 处理一下sliderSize，弄成整数，以免计算有偏差
    sliderBaseSize: function sliderBaseSize() {
      return Math.max(Math.min(Math.round(this.sliderSize), Math.round(this.canvasWidth * 0.5)), 10);
    }
  },
  /** 方法 **/
  methods: {
    changeBtn: function changeBtn() {
      this.isShow = true;
    },
    // 关闭
    onClose: function onClose() {
      if (!this.mouseDown && !this.isSubmting) {
        clearTimeout(this.timer1);
      }
    },
    onCloseMouseDown: function onCloseMouseDown() {
      this.closeDown = true;
      this.isShow = false;
      this.init(true);
      //给父组件传一个状态
      this.$emit('submit', 'F');
    },
    onCloseMouseUp: function onCloseMouseUp() {
      if (this.closeDown) {
        this.onClose();
      }
      this.closeDown = false;
    },
    // 鼠标按下准备拖动
    onRangeMouseDown: function onRangeMouseDown(e) {
      // if (this.isCanSlide) {
      this.mouseDown = true;
      this.startWidth = this.$refs["range-slider"].clientWidth;
      this.newX = e.clientX || e.changedTouches[0].clientX;
      this.startX = e.clientX || e.changedTouches[0].clientX;
      // }
    },
    // 鼠标移动
    onRangeMouseMove: function onRangeMouseMove(e) {
      if (this.mouseDown) {
        // e.preventDefault();
        this.newX = e.clientX || e.changedTouches[0].clientX;
      }
    },
    // 鼠标抬起
    onRangeMouseUp: function onRangeMouseUp() {
      if (this.mouseDown) {
        this.mouseDown = false;
        this.submit();
      }
    },
    /**
     * 开始进行
     * @param withCanvas 是否强制使用canvas随机作图
     */
    // 工具 - 范围随机数
    getRandom: function getRandom(min, max) {
      return Math.ceil(Math.random() * (max - min) + min);
    },
    drawPuzzlePiece: function drawPuzzlePiece() {
      var c2 = this.$refs.canvas2;
      var ctx2 = c2.getContext("2d", {
        willReadFrequently: true
      });

      // 清空画布
      ctx2.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

      // 获取拼图块的图像数据
      var imgData = this.ctx.getImageData(this.pinX, this.pinY, this.puzzleBaseSize, this.puzzleBaseSize);

      // 将拼图块图像数据绘制到左边的canvas
      ctx2.putImageData(imgData, 0, 0);
    },
    init: function init() {
      var _this = this;
      // 防止重复加载导致的渲染错误
      if (this.loading) {
        return;
      }
      this.loading = (0, _utils.load)();
      this.isCanSlide = false;
      var c = this.$refs.canvas1;
      var c2 = this.$refs.canvas2;
      var c3 = this.$refs.canvas3;
      var ctx = c.getContext("2d", {
        willReadFrequently: true
      });
      var ctx2 = c2.getContext("2d", {
        willReadFrequently: true
      });
      var ctx3 = c3.getContext("2d", {
        willReadFrequently: true
      });
      var isFirefox = navigator.userAgent.indexOf("Firefox") >= 0 && navigator.userAgent.indexOf("Windows") >= 0; // 是windows版火狐

      var img = new Image();
      img.src = require("../../../../assets/img/bj_yanzheng.png");
      img.crossOrigin = "anonymous"; // 匿名，想要获取跨域的图片
      ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      ctx2.clearRect(0, 0, 70, this.canvasHeight);
      // 取一个随机坐标，作为拼图块的位置
      this.pinX = this.getRandom(this.puzzleBaseSize, this.canvasWidth - this.puzzleBaseSize - 20); // 留20的边距
      this.pinY = this.getRandom(20, this.canvasHeight - this.puzzleBaseSize - 20); // 主图高度 - 拼图块自身高度 - 20边距

      img.onload = function () {
        // 清空画布
        // ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        // ctx2.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

        // 将加载的图片绘制到 canvas1 上
        // ctx.drawImage(img, 0, 0, this.canvasWidth, this.canvasHeight);

        // 生成拼图块
        var _this$makeImgSize = _this.makeImgSize(img),
          _this$makeImgSize2 = (0, _slicedToArray2.default)(_this$makeImgSize, 4),
          x = _this$makeImgSize2[0],
          y = _this$makeImgSize2[1],
          w = _this$makeImgSize2[2],
          h = _this$makeImgSize2[3];
        ctx.save();
        _this.paintBrick(ctx);
        ctx.closePath();
        if (!isFirefox) {
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 0;
          ctx.shadowColor = "#000";
          ctx.shadowBlur = 0;
          ctx.fill();
          ctx.clip();
        } else {
          ctx.clip();
          ctx.save();
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 0;
          ctx.shadowColor = "#000";
          ctx.shadowBlur = 0;
          ctx.fill();
          ctx.restore();
        }
        ctx.drawImage(img, x, y, w, h);
        ctx3.fillRect(0, 0, _this.canvasWidth, _this.canvasHeight);
        ctx3.drawImage(img, x, y, w, h);

        // 设置小图的内阴影
        ctx.globalCompositeOperation = "source-atop";
        _this.paintBrick(ctx);
        ctx.arc(_this.pinX + Math.ceil(_this.puzzleBaseSize / 2), _this.pinY + Math.ceil(_this.puzzleBaseSize / 2), _this.puzzleBaseSize * 1.2, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.shadowColor = "rgba(255, 255, 255, 1)";
        ctx.shadowOffsetX = -1;
        ctx.shadowOffsetY = -1;
        ctx.shadowBlur = Math.min(Math.ceil(8 * _this.puzzleScale), 12);
        ctx.fillStyle = "#fff";
        ctx.fill();
        var imgData = ctx.getImageData(_this.pinX - 3,
        // 为了阴影 是从-3px开始截取，判定的时候要+3px
        _this.pinY - 20, _this.puzzleBaseSize + 5, _this.puzzleBaseSize + 8);
        ctx2.putImageData(imgData, 0, _this.pinY - 20);

        // 清理
        ctx.restore();
        ctx.clearRect(0, 0, _this.canvasWidth, _this.canvasHeight);

        // 画缺口
        ctx.save();
        _this.paintBrick(ctx);
        ctx.globalAlpha = 1;
        ctx.fillStyle = "#ffffff";
        ctx.fill();
        ctx.restore();

        // 画缺口的内阴影
        ctx.save();
        ctx.globalCompositeOperation = "source-atop";
        _this.paintBrick(ctx);
        ctx.arc(_this.pinX + Math.ceil(_this.puzzleBaseSize / 2), _this.pinY + Math.ceil(_this.puzzleBaseSize / 2), _this.puzzleBaseSize * 1.2, 0, Math.PI * 2, true);
        ctx.shadowColor = "#ffffff";
        ctx.shadowOffsetX = 2;
        ctx.shadowOffsetY = 2;
        ctx.shadowBlur = 16;
        ctx.fill();
        ctx.restore();

        // 画整体背景图
        ctx.save();
        ctx.globalCompositeOperation = "destination-over";
        ctx.drawImage(img, x, y, w, h);
        ctx.restore();
        _this.loading.close();
        _this.isCanSlide = true;
      };
      img.onerror = function () {
        _this.init(true); // 如果图片加载错误就重新来，并强制用canvas随机作图
      };
    },
    // 工具 - 设置图片尺寸cover方式贴合canvas尺寸 w/h
    makeImgSize: function makeImgSize(img) {
      var imgScale = img.width / img.height;
      var canvasScale = this.canvasWidth / this.canvasHeight;
      var x = 0,
        y = 0,
        w = 0,
        h = 0;
      if (imgScale > canvasScale) {
        h = this.canvasHeight;
        w = imgScale * h;
        y = 0;
        x = (this.canvasWidth - w) / 2;
      } else {
        w = this.canvasWidth;
        h = w / imgScale;
        x = 0;
        y = (this.canvasHeight - h) / 2;
      }
      // console.log([x, y, w, h],'3333333333');
      return [x, y, w, h];
    },
    // 绘制拼图块的路径
    paintBrick: function paintBrick(ctx) {
      var moveL = Math.ceil(15 * this.puzzleScale); // 直线移动的基础距离
      ctx.beginPath();
      ctx.moveTo(this.pinX, this.pinY);
      ctx.lineTo(this.pinX + moveL, this.pinY);
      ctx.arcTo(this.pinX + moveL, this.pinY - moveL / 2, this.pinX + moveL + moveL / 2, this.pinY - moveL / 2, moveL / 2);
      ctx.arcTo(this.pinX + moveL + moveL, this.pinY - moveL / 2, this.pinX + moveL + moveL, this.pinY, moveL / 2);
      ctx.lineTo(this.pinX + moveL + moveL + moveL, this.pinY);
      ctx.lineTo(this.pinX + moveL + moveL + moveL, this.pinY + moveL);
      ctx.arcTo(this.pinX + moveL + moveL + moveL + moveL / 2, this.pinY + moveL, this.pinX + moveL + moveL + moveL + moveL / 2, this.pinY + moveL + moveL / 2, moveL / 2);
      ctx.arcTo(this.pinX + moveL + moveL + moveL + moveL / 2, this.pinY + moveL + moveL, this.pinX + moveL + moveL + moveL, this.pinY + moveL + moveL, moveL / 2);
      ctx.lineTo(this.pinX + moveL + moveL + moveL, this.pinY + moveL + moveL + moveL);
      ctx.lineTo(this.pinX, this.pinY + moveL + moveL + moveL);
      ctx.lineTo(this.pinX, this.pinY + moveL + moveL);
      ctx.arcTo(this.pinX + moveL / 2, this.pinY + moveL + moveL, this.pinX + moveL / 2, this.pinY + moveL + moveL / 2, moveL / 2);
      ctx.arcTo(this.pinX + moveL / 2, this.pinY + moveL, this.pinX, this.pinY + moveL, moveL / 2);
      ctx.lineTo(this.pinX, this.pinY);
    },
    // 用canvas随机生成图片
    makeImgWithCanvas: function makeImgWithCanvas() {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d", {
        willReadFrequently: true
      });
      canvas.width = this.canvasWidth;
      canvas.height = this.canvasHeight;
      ctx.fillStyle = "rgb(".concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ")");
      ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
      // 随机画10个图形
      for (var i = 0; i < 12; i++) {
        ctx.fillStyle = "rgb(".concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ")");
        ctx.strokeStyle = "rgb(".concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ",").concat(this.getRandom(100, 255), ")");
        if (this.getRandom(0, 2) > 1) {
          // 矩形
          ctx.save();
          ctx.rotate(this.getRandom(-90, 90) * Math.PI / 180);
          ctx.fillRect(this.getRandom(-20, canvas.width - 20), this.getRandom(-20, canvas.height - 20), this.getRandom(10, canvas.width / 2 + 10), this.getRandom(10, canvas.height / 2 + 10));
          ctx.restore();
        } else {
          // 圆
          ctx.beginPath();
          var ran = this.getRandom(-Math.PI, Math.PI);
          ctx.arc(this.getRandom(0, canvas.width), this.getRandom(0, canvas.height), this.getRandom(10, canvas.height / 2 + 10), ran, ran + Math.PI * 1.5);
          ctx.closePath();
          ctx.fill();
        }
      }
      return canvas.toDataURL("image/png");
    },
    // 开始判定
    submit: function submit() {
      var _this2 = this;
      this.isSubmting = true;
      // 偏差 x = puzzle的起始X - (用户真滑动的距离) + (puzzle的宽度 - 滑块的宽度) * （用户真滑动的距离/canvas总宽度）
      // 最后+ 的是补上slider和滑块宽度不一致造成的缝隙
      var x = Math.abs(this.pinX - (this.styleWidth - this.sliderBaseSize) + (this.puzzleBaseSize - this.sliderBaseSize) * ((this.styleWidth - this.sliderBaseSize) / (this.canvasWidth - this.sliderBaseSize)) - 3);
      if (x < this.range) {
        // 成功
        this.infoText = this.successText;
        this.infoBoxFail = false;
        this.infoBoxShow = true;
        this.isCanSlide = false;
        this.isSuccess = false;
        // 成功后准备关闭
        clearTimeout(this.timer1);
        this.timer1 = setTimeout(function () {
          // 成功的回调
          _this2.isSubmting = false;
          _this2.isShow = false;
          _this2.verSuccess = true;
          _this2.$emit('submit', 'F', _this2.verSuccess);
          _this2.$emit('verified'); // 触发验证通过事件
          _this2.reset();
        }, 800);
      } else {
        // 失败
        this.infoText = this.failText;
        this.infoBoxFail = true;
        this.infoBoxShow = true;
        this.isCanSlide = false;
        // 失败的回调
        // this.$emit("fail", x);
        // 800ms后重置
        clearTimeout(this.timer1);
        this.timer1 = setTimeout(function () {
          _this2.isSubmting = false;
          _this2.reset();
        }, 800);
      }
    },
    // 重置 - 重新设置初始状态
    resetState: function resetState() {
      this.infoBoxFail = false;
      this.infoBoxShow = false;
      this.isCanSlide = false;
      this.isSuccess = false;
      this.startWidth = this.sliderBaseSize; // 鼠标点下去时父级的width
      this.startX = 0; // 鼠标按下时的X
      this.newX = 0; // 鼠标当前的偏移X
    },
    // 重置
    reset: function reset() {
      if (this.isSubmting) {
        debugger;
        return;
      }
      this.resetState();
      this.init();
    },
    open: function open() {
      this.showData = true;
    },
    close: function close() {
      this.showData = false;
    },
    onVerified: function onVerified() {
      this.close();
      this.$emit('verified');
    }
  }
};